const AceOcnVesselMasterKeys = {
  TITLE: "title",
  VESSEL_CODE: "vesselCode",
  VESSEL_NAME: "vesselName",
  VESSEL_OWNER: "vesselOwner",
  VESSEL_COUNTRY: "vesselCountry"
}

export default AceOcnVesselMasterKeys
